import { DbEnum } from "../generated/prisma-enums";

/**
 * Narrows a free-form provider string to the provider enum.
 *
 * Provider names arrive as plain strings from API payloads and stored config
 * snapshots. Indexing a provider-keyed object with one of those directly reaches
 * the object's prototype for names like `constructor` or `toString`, yielding a
 * truthy non-value that slips past a `??` default — so membership is checked
 * before the lookup, never after.
 */
export function isModelProvider(value: string): value is DbEnum.ModelProvider {
  return (DbEnum.MODEL_PROVIDER_VALUES as readonly string[]).includes(value);
}
